import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    sellerName,
    sellerTaxCode,
    sellerPhone,
    sellerAddress,
    sellerBankAccount,
    buyerName,
    buyerTaxCode,
    buyerAddress,
    buyerBankAccount,
    day,
    payments,
    currency,
    invoiceSymbol,
    number,
    status,
  },
} = checkout;

const validations = Yup.object().shape({
  [sellerName.name]: Yup.string().required(sellerName.errorMsg),
  [sellerTaxCode.name]: Yup.string().required(sellerTaxCode.errorMsg),
  [sellerPhone.name]: Yup.string().required(sellerPhone.errorMsg),
  [sellerAddress.name]: Yup.string().required(sellerAddress.errorMsg),
  [sellerBankAccount.name]: Yup.string().required(sellerBankAccount.errorMsg),
  [buyerName.name]: Yup.string().required(buyerName.errorMsg),
  [buyerTaxCode.name]: Yup.string().required(buyerTaxCode.errorMsg),
  [buyerAddress.name]: Yup.string().required(buyerAddress.errorMsg),
  [buyerBankAccount.name]: Yup.string().required(buyerBankAccount.errorMsg),
  [day.name]: Yup.number().required(day.errorMsg),
  [payments.name]: Yup.string().required(payments.errorMsg),
  [currency.name]: Yup.string().required(currency.errorMsg),
  [invoiceSymbol.name]: Yup.string().notRequired(),
  [number.name]: Yup.number().notRequired(),
  [status.name]: Yup.string().required(status.errorMsg),
});

export default validations;
